import { ENV } from '@environment';
import { countries } from 'api';

import { RestCountryResponse } from 'models/restCountry';

const fallbackResponse: RestCountryResponse[] = [
  { name: 'Argentina', alpha2Code: 'AR', callingCodes: ['54'], flag: 'https://restcountries.com/data/arg.svg' },
  { name: 'Brazil', alpha2Code: 'BR', callingCodes: ['55'], flag: 'https://restcountries.com/data/bra.svg' },
  { name: 'Chile', alpha2Code: 'CL', callingCodes: ['56'], flag: 'https://restcountries.com/data/chl.svg' },
  { name: 'Colombia', alpha2Code: 'CO', callingCodes: ['57'], flag: 'https://restcountries.com/data/col.svg' },
  { name: 'Costa Rica', alpha2Code: 'CR', callingCodes: ['506'], flag: 'https://restcountries.com/data/cri.svg' },
  { name: 'Ecuador', alpha2Code: 'EC', callingCodes: ['593'], flag: 'https://restcountries.com/data/ecu.svg' },
  { name: 'Mexico', alpha2Code: 'MX', callingCodes: ['52'], flag: 'https://restcountries.com/data/mex.svg' },
  { name: 'Peru', alpha2Code: 'PE', callingCodes: ['51'], flag: 'https://restcountries.com/data/per.svg' },
  { name: 'Uruguay', alpha2Code: 'UY', callingCodes: ['598'], flag: 'https://restcountries.com/data/ury.svg' },
];

const API_COUNTRIES = ENV.API.COUNTRIES;

export const getAll = () =>
  countries
    .get(`${API_COUNTRIES}all`, {
      params: { fields: 'name;alpha2Code;flag;callingCodes' },
      timeout: 5000,
    })
    .then((response: { data: RestCountryResponse[] }) => response.data)
    .catch(() => fallbackResponse);

export const getFlagByAlpha2 = async (alpha: string) => {
  try {
    const url = `${API_COUNTRIES}alpha/${alpha}`;
    const response = await countries.get(url, {
      params: { fields: 'flag' },
      timeout: 5000,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
